import Player from "@mux/mux-player-react";
import {useRecoilValue, useResetRecoilState, useSetRecoilState} from "recoil";
import playerState from "../../state/ui/playerState";
import { useEffect, useRef, useState } from "react";

const MuxPlayer = ({src, sync, loop, provider, token, ...props}) => {
    const setPlayerState = useSetRecoilState(playerState);
    const resetPlayerState = useResetRecoilState(playerState);
    const muxPlyr = useRef(null);
    const [videoQualities, setVideoQualities] = useState([]);
    const playerStateValue = useRecoilValue(playerState);
    const playerStateRef = useRef();

    useEffect(() => {
        playerStateRef.current = playerStateValue;
    }, [playerStateValue]);

    useEffect(() => {
        setPlayerState(old => ({
            ...old,
            muted: muxPlyr.current.muted,
        }));

        window.SpacePlayer = {
            requestFullscreen: () => muxPlyr.current.requestFullscreen(),
            exitFullscreen: () => muxPlyr.current.exitFullscreen(),
            mute: () => muteMuxPlyrHandler(),
            unmute: () => unMuteMuxPlyrHandler(),
            setQuality: null, // set as null here, setting modal and gear icon will check this and conditionally hide
            setTrack: null, // set as null here, setting modal and gear icon will check this and conditionally hide
        };

        const muteMuxPlyrHandler = () => {
            // Hacky way to mute as mux-player doesn't provide api for this
            muxPlyr.current.muted = true;
            setPlayerState(old => ({
                ...old,
                muted: true,
            }));
        }

        const unMuteMuxPlyrHandler = () => {
            // Hacky way to unmute as mux-player doesn't provide api for this
            muxPlyr.current.muted = false;
            setPlayerState(old => ({
                ...old,
                muted: false,
            }));
        }

        const setQualityMuxPlyrHandler = (quality) => {
            // Hacky way to set quality as mux-player doesn't provide api for this (UNUSED FOR NOW)
            muxPlyr.current.videoRenditions.selectedIndex = parseInt(quality);
            setPlayerState(old => ({
                ...old,
                selectedQuality: videoQualities.find(i => i.id === quality),
            }));
        }

        const setDisableTextTrackMuxPlyrHandler = () => {
            // Hacky way to disable text track as mux-player doesn't provide api for this (buggy) (UNUSED FOR NOW)
            const currentTrackIndex = playerStateRef.current?.selectedTrack;
            if (currentTrackIndex && muxPlyr.current?.textTracks?.[currentTrackIndex]) {
                muxPlyr.current.textTracks[currentTrackIndex].mode = 'disabled';
            }
            setPlayerState(old => ({
                ...old,
                selectedTrack: '-1',
            }));
        }

        const setEnableTextTrackMuxPlyrHandler = (track) => {
            // Hacky way to set text track as mux-player doesn't provide api for this (buggy) (UNUSED FOR NOW)
            if (muxPlyr.current?.textTracks?.[track]) {
                muxPlyr.current.textTracks[track].mode = 'showing';
            }
            setPlayerState(old => ({
                ...old,
                selectedTrack: track,
            }));
        }

        // (UNUSED FOR NOW, LEAVE FOR USER TO CLICK ON THE MUX PLAYER)
        // muxPlyr.current.addEventListener('loadeddata', () => {
        //     Promise.all([
        //         muxPlyr.current.videoRenditions,
        //         muxPlyr.current.textTracks,
        //     ]).then(([videoRenditions, textTracks]) => {
        //         // Get the list of qualities
        //         const qualities = Array.from(videoRenditions).map(item => ({
        //             id: item.id,
        //             label: item.height,
        //         }));
                
        //         // Prepend auto quality
        //         qualities.unshift({
        //             id: '-1',
        //             label: 'Auto'
        //         })

        //         // Get the list of tracks
        //         const tracks = Array.from(textTracks).map((item, index) => {
        //             if(item.kind === 'subtitles') {
        //                 return {
        //                     id: index.toString(),
        //                     label: item.label,
        //                 };
        //             }
        //         }).filter(i => i);

        //         // Prepend no track (off)
        //         tracks.unshift({
        //             id: '-1',
        //             label: 'Off'
        //         })

        //         setVideoQualities(qualities);
        //         setPlayerState(old => ({
        //             ...old,
        //             qualities: qualities,
        //             selectedQuality: videoRenditions.selectedIndex.toString(),
        //             tracks: tracks,
        //             selectedTrack: Array.from(textTracks).findIndex(i => i.mode === 'showing' && i.kind === 'subtitles').toString(),
        //         }))
        //     });
        // });

        return () => {
            delete window.SpacePlayer;

            return () => {
                resetPlayerState();
            }
        };
    }, [])

    return (
        <Player
            ref={muxPlyr}
            playbackId={src}
            loop={loop}
            muted={false}
            tokens={{ playback: token }}
            autoPlay
        />
    )
}

export default MuxPlayer;
